import { iconHTML } from "discourse/lib/icon-library";
import { withPluginApi } from "discourse/lib/plugin-api";
import { i18n } from "discourse-i18n";

const PLUGIN_ID = "hosted-site";

function initialize(api) {
  const currentUser = api.getCurrentUser();
  if (!currentUser?.admin) {
    return;
  }

  api.modifyClass("component:modal/start-backup", {
    pluginId: PLUGIN_ID,

    get canManageUploadsInBackup() {
      return false;
    },

    get warningMessage() {
      if (!this.siteSettings.include_s3_uploads_in_backups) {
        return (
          iconHTML("triangle-exclamation") +
          i18n("hosted_site.admin_backup_upload_warning") +
          iconHTML("triangle-exclamation")
        );
      }
      return "";
    },

    get warningCssClasses() {
      if (!this.siteSettings.include_s3_uploads_in_backups) {
        return "alert alert-warning";
      }
      return "";
    },
  });
}

export default {
  name: "extend-admin-start-backup",
  initialize(container) {
    withPluginApi((api) => initialize(api, container));
  },
};
